import getResultsGroups from './getResultsGroups';

/**
 * Given data, determine if results contain elements with 'group' type.
 *
 * @param {array} array - array of results.
 * @returns {bool} true if groups exist.
 */
export default function hasResultsGroups(array) {
  return 0 < getResultsGroups(array).length;
}
